module.exports = __webpack_public_path__ + "img/gaji_config.69cbf591.png";